import { Link } from 'react-router-dom';

const Gallery = () => {
  const images = [
    {
      src: '/images/CPR-Training-small-1-768x518.jpg',
      alt: 'CPR Training'
    },
    {
      src: '/images/13-1-768x859.jpg',
      alt: 'Program Activity'
    },
    {
      src: '/images/11-1-768x859.jpg',
      alt: 'Group Activity'
    },
    {
      src: '/images/12-1-768x859.jpg',
      alt: 'Training Session'
    },
    {
      src: '/images/1cdc0a73-32f2-4f93-b324-c81707d21c63.jpg',
      alt: 'Participant'
    },
    {
      src: '/images/ProgramMember01.jpg',
      alt: 'Program Member'
    },
    {
      src: '/images/9b3cb6ec-cb95-4bf8-a6e1-bdca5884af77.jpg',
      alt: 'Activity'
    },
    {
      src: '/images/d1a3198a-5ca0-4e29-9583-9033243bcf55.jpg',
      alt: 'Training'
    }
  ];

  return (
    <section className="py-28 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider bg-teal-50 px-5 py-2 rounded-full">Our Community</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">Gallery</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Explore moments from our programs and see the positive impact we make every day
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {images.map((image, index) => (
            <div 
              key={index}
              className="relative aspect-square rounded-2xl overflow-hidden group cursor-pointer shadow-md hover:shadow-2xl transition-all hover:-translate-y-1"
            >
              <img 
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform">
                <p className="font-semibold text-lg">{image.alt}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/gallery" 
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-lg hover:bg-teal-700 transition-all font-semibold text-lg shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            View All Gallery
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
